import { API_STATES } from "@/helpers";

const state = {
  overtimerulesGetState   : API_STATES.NOT_REQUESTED,
  overtimerulesGetError   : null,
  overtimeRules           : [],
  deleteOvertimeRuleState : API_STATES.NOT_REQUESTED,
  deleteOvertimeRuleError : null,
  applyOvertimeRuleState  : API_STATES.NOT_REQUESTED,
  applyOvertimeRuleError  : null
};

export default state;